var _path, _path2, _line, _line2, _path3, _path4, _line3, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningClock = function SvgWarningClock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 81,
    viewBox: "0 0 84 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.7093 42.4919C70.7093 56.6803 58.1584 68.2894 42.5382 68.2894C26.918 68.2894 14.3672 56.6803 14.3672 42.4919C14.3672 28.3034 26.918 16.6943 42.5382 16.6943C58.1584 16.6943 70.7093 28.3034 70.7093 42.4919Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0625 23.9766V46.2888",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 8.50954,
    y2: -0.5,
    transform: "matrix(0.447861 0.894103 -0.914047 0.405608 56.2031 65.4395)",
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 8.20266,
    y2: -0.5,
    transform: "matrix(-0.557253 0.830342 -0.859558 -0.511038 26.0547 63.7422)",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1108 26.4011L14.8618 21.1447L20.5842 16.3761",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1701 16.5532L69.4556 21.3363L74.1646 27.0024",
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40.3984,
    y1: 9.49805,
    x2: 40.3984,
    y2: 17.2032,
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9219 8.29688H45.0733L44.7165 11.6421H39.1168L38.9219 8.29688Z",
    fill: "#F5F5F5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningClock);
export { ForwardRef as ReactComponent };